import * as React from 'react'
import moment from 'moment'
import { IInventoryLog } from '@getgreenline/inventory/build/models/inventoryLog'
import { LoadingAnimation } from '../../../../../components/LoadingAnimation'
import { Icon, List, Row, Statistic, Result } from 'antd'

interface Props {
  inventoryLogs?: IInventoryLog[]
}

export const InventoryLog = (props: Props) => {
  const { inventoryLogs } = props

  if (!inventoryLogs) {
    return <LoadingAnimation />
  }

  if (inventoryLogs.length === 0) {
    return <Result status='info' title='No inventory changes yet' />
  }

  return (
    <div>
      <Row>
        <div className='text-muted'>
          <span>Completed by: </span>
          <span>{inventoryLogs[0].userName}</span>
        </div>

        <div className='text-muted'>
          <span>Create date: </span>
          <span>{moment(inventoryLogs[0].createDate).format('MMM D, YYYY hh:mm a')}</span>
        </div>
      </Row>

      <hr className='mt-4 mb-4' style={{ marginLeft: '-24px', marginRight: '-24px' }} />

      <Row>
        <List
          bordered
          dataSource={inventoryLogs}
          renderItem={(log) => {
            let iconType: string | undefined = log.updateValue > 0 ? 'caret-up' : 'caret-down'

            if (log.updateValue === 0) {
              iconType = undefined
            }

            return (
              <List.Item>
                <Statistic
                  title={log.productName}
                  value={log.updateValue}
                  valueStyle={{ color: log.updateValue > 0 ? 'green' : 'red' }}
                  prefix={<Icon type={iconType} />}
                  suffix={
                    <small className='ml-2 text-muted text-right'>
                      {log.previousValue} <Icon type='arrow-right' /> {log.newValue}
                    </small>
                  }
                />
              </List.Item>
            )
          }}
        />
      </Row>
    </div>
  )
}
